<template lang="pug">
b-modal#addThemeContent(
  ref="addThemeContent"
  :title="$t('ui.combine.add_theme_content')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.content_id')").mb-1
      DebounceInput(
        size="sm"
        ref="content_id"
        required
        type="text"
        :dirty="$v.content_id.$dirty"
        :error="$v.content_id.$error"
        v-model.trim.lazy="$v.content_id.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.content_id" :name="$t('ui.content_id')")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      content_id: ''
    };
  },
  validations: {
    content_id: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(30),
      noSpace: function(value) {
        const regexp = /^\S*$/.test(value);
        return regexp
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addContentUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          content_id: this.content_id
        };

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_theme_content", this.feedback.status);
              }
              this.$nextTick(() => {
                this.$refs.addThemeContent.hide();
              });
            }
          } catch (error) {
            this.loading = false;
            if (error.status.toLowerCase() == "nochanges") {
              this.$emit("clicked");
              this.$nextTick(() => {
                this.$refs.addThemeContent.hide();
              });
            } else {
              this.feedback.success = false;
              this.feedback.status = error.status;
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.handleFeedback(this.feedback.status);
        }
      );
      }
    },
    reset() {
      this.content_id = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.$refs.content_id.$el.focus();
    }
  }
};
</script>
